import React from "react";
import { Container, Typography, Box, IconButton, useTheme } from "@mui/material";
import { Facebook, Pinterest, LinkedIn, YouTube, Instagram } from "@mui/icons-material";

const SocialMediaSection = () => {
  const theme = useTheme(); // Access theme to adjust background color

  return (
    <section
      className="social-media-section"
      style={{
        padding: "2rem 0",
        backgroundColor: theme.palette.mode === "dark" ? "#333" : "#f4f4f4", // Dark mode support
      }}
    >
      <Container maxWidth="lg" sx={{ textAlign: "center" }}>
        <Typography variant="h5" gutterBottom sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000" }}>
          Follow Us
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <IconButton color="primary" href="https://facebook.com" target="_blank" aria-label="Facebook">
            <Facebook />
          </IconButton>
          <IconButton color="primary" href="https://pinterest.com" target="_blank" aria-label="Pinterest">
            <Pinterest />
          </IconButton>
          <IconButton color="primary" href="https://linkedin.com" target="_blank" aria-label="LinkedIn">
            <LinkedIn />
          </IconButton>
          <IconButton color="primary" href="https://youtube.com" target="_blank" aria-label="YouTube">
            <YouTube />
          </IconButton>
          <IconButton color="primary" href="https://www.instagram.com/rocketoffer/" target="_blank" aria-label="Instagram">
            <Instagram />
          </IconButton>
        </Box>
      </Container>
    </section>
  );
};

export default SocialMediaSection;